import { computed, ref } from "vue"
import { countVisibleItems } from "../utils/filterable_list"
import { filterItemsByLetterAndType } from "../utils/book_contents_filter"
import { scrollToLetter } from "../utils/filterable_list"

export function useBookContentsFilter(itemsByLetter) {
  const query = ref("")
  const typeFilter = ref("all")
  const viewMode = ref("list")
  const currentLetter = ref(null)
  const showScrollToFilters = ref(false)
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("")

  const filteredGroups = computed(() =>
    filterItemsByLetterAndType(itemsByLetter, query.value, typeFilter.value)
  )

  const visibleCount = computed(() => countVisibleItems(filteredGroups.value))
  const showNoResults = computed(() => visibleCount.value === 0)

  const sortedGroups = computed(() =>
    Object.entries(filteredGroups.value).sort(([a], [b]) => a.localeCompare(b))
  )

  function letterHasItems(letter) {
    return Boolean(filteredGroups.value[letter]?.length)
  }

  function sectionId(letter) {
    return viewMode.value === "cards" ? `letter-${letter}-cards` : `letter-${letter}`
  }

  function jumpToLetter(event, letter) {
    event.preventDefault()
    if (!letterHasItems(letter)) return

    const target = document.getElementById(sectionId(letter))
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" })
      return
    }

    scrollToLetter(letter)
  }

  function setViewMode(mode) {
    viewMode.value = mode
  }

  function setTypeFilter(value) {
    typeFilter.value = value
  }

  function handleScroll(toolbarSelector = ".book-toolbar") {
    const scrolled = window.pageYOffset
    showScrollToFilters.value = scrolled > window.innerHeight
    updateActiveAlphabetLetter()
  }

  function updateActiveAlphabetLetter() {
    let activeLetter = null

    for (const [letter] of sortedGroups.value) {
      const element = document.getElementById(sectionId(letter))
      if (!element || element.style.display === "none") continue

      const rect = element.getBoundingClientRect()
      if (rect.top <= 150 && rect.bottom > 150) {
        activeLetter = letter
        break
      }
    }

    currentLetter.value = activeLetter
  }

  function scrollToFilters(toolbarSelector = ".book-toolbar") {
    const toolbar = document.querySelector(toolbarSelector)
    if (!toolbar) return

    toolbar.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  return {
    query,
    typeFilter,
    viewMode,
    currentLetter,
    showScrollToFilters,
    letters,
    filteredGroups,
    sortedGroups,
    showNoResults,
    letterHasItems,
    sectionId,
    jumpToLetter,
    setViewMode,
    setTypeFilter,
    handleScroll,
    scrollToFilters,
  }
}
